<template lang="html">
	<div class="editor" id="editor"></div>
</template>
<script>
import wangEditor from 'wangeditor'
export default {
	name: 'editoritem',
	data() {
		return {
			editor: null,
			info_: null
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		isClear: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		isClear(val) {
			if (val) {
				this.editor.txt.clear()
				this.info_ = null
			}
		},
		value: function (value) {
			if (value !== this.editor.txt.html()) {
				this.editor.txt.html(this.value)
			}
		}
	},
	mounted() {
		const this_=this;
		const baseUrl = process.env.API_IMGURL;
		const editor = new wangEditor('#editor');
		editor.config.height = 200;
		editor.config.showLinkImg = false;
		editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
        editor.config.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
        editor.config.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
		editor.config.customUploadImg = function (resultFiles, insertImgFn) {
			if (resultFiles&&resultFiles.length>0) {
				for (var i = 0; i < resultFiles.length; i++) {
					let formData = new FormData() 
		            formData.append('file', resultFiles[i]);
		            formData.append('sub_url','editor');
		            var url="admin_business_api/image_up";
		            this_.$post(url, formData).then((res) => {
		            	if (res.image&&res.image.length>0) {
		            		var imgUrl = baseUrl+res.image[0];
						    insertImgFn(imgUrl)
		            	}
					});
				}
			}
		};
		editor.config.menus = [
			"head", // 标题
			"bold", // 粗体
			"fontSize", // 字号
			"fontName", // 字体
			"italic", // 斜体
			"underline", // 下划线
			"strikeThrough", // 删除线
			"foreColor", // 文字颜色
			"backColor", // 背景颜色
			"link", // 插入链接
			"list", // 列表
			"justify", // 对齐方式
			"quote", // 引用
			//"emoticon", // 表情
			"image", // 插入图片
			"table", // 表格
			//"video", // 插入视频
			//"code", // 插入代码
			"undo", // 撤销
			"redo", // 重复
			"fullscreen", // 全屏
		];

		editor.config.onchange = (newHtml) => {
			this.info_ = newHtml;
			this.$emit('change', this.info_);
		}
		// 创建编辑器
		editor.create()
		this.editor = editor;
		this.editor.txt.html(this.value)
	},
	methods: {
	},
	beforeDestroy() {
		this.editor.destroy();
		this.editor = null
	}
}
</script>
<style>
.editor {
	width: 100%;
	margin: 0 auto;
	position: relative;
	z-index: 0;
}
.editor img{
	display: initial;
}
.editor a{
	display: initial;
}

</style>



// WEBPACK FOOTER //
// src/components/wangEnduit.vue